import React from "react"
import { customerData } from "../../../utilities/CustomerData"

export function DashboardMailedOffice() {
  function MultilineText({ text, textColor }) {
        const lines = text.split('\\n')
    
        const renderTextWithItalics = (text) => {
          const parts = text.split(/(<i>|<\/i>|<b>|<\/b>)/)
          let isInItalic = false
          let isInBold = false
    
          return parts.map((part, index) => {
            if (part === "<i>") {
              isInItalic = true
              return null
            } else if (part === "</i>") {
              isInItalic = false
              return null
            } else if (part === '<b>') {
              isInBold = true
              return null
            } else if (part === '</b>') {
              isInBold = false
              return null
            } else {
              if (isInItalic && isInBold) {
                return (
                  <b key={index}>
                    <i>{part}</i>
                  </b>
                )
              } else if (isInItalic)
                return <i key={index}>{part}</i>
              else if (isInBold)
                return <b key={index}>{part}</b>
              else
                return part
            }
          })
        }
    
        return (
          <div className={`text-left text-${textColor} mt-4`}>
            {lines.map((line, index) => (
              <React.Fragment key={index}>
                {renderTextWithItalics(line)}
                {index !== lines.length - 1 && <><br /><div style={{ height: '8px' }} /></>}
              </React.Fragment>
            ))}
          </div>
        )
      }
  
    return (
      <div className='lg:w-full w-11/12 flex flex-col gap-4'>
        <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-robo text-white'>
          <div className='w-full flex flex-col items-center gap-4'>
            <p className='font-bold text-3xl text-center'>Mailed To Office</p>
            <p className='font-bold text-xl text-center'>Packet On its Way!</p>
            <p className='p-2 rounded-lg text-3xl font-bold bg-red-500 text-center'>No Additional Step Required at the Time</p>
            <p className='text-center'>E-Signature Documents available in estimated 2-3 days! You will be notified via text and email!</p>
          </div>
        </div>
        <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-robo text-white'>
          <MultilineText text={customerData.customerStageHistory.find(stage => stage.currentStage === true).customerStageDesc} textColor={'white'} />
        </div>
      </div>
    )
}